import {
  Link,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Collapse,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import ExpandLess from "@material-ui/icons/ExpandLess";
import { B } from "@mobily/ts-belt";
import PropTypes from "prop-types";
import * as React from "react";
import { stepIndex, steps, shipmentStatus } from "../../../util/orderStatus";
import ShipmentItem from "./ShipmentItem";
import ShipmentTotals from "./ShipmentTotals";

export default function Shipment({
  order,
  shipment,
  shipmentNumber,
  hasMultipleShipments,
  refresh,
}) {
  const [open, setOpen] = React.useState(false);
  const status = shipmentStatus(shipment, (x) => x);
  const step = stepIndex(status);

  return (
    <Box key={`${shipmentNumber}-${shipment.shipmentId}`}>
      <Card elevation={0}>
        <CardHeader
          title={
            <Typography variant="h6">
              {shipment.hasNoShipping
                ? "No Shipping Required"
                : `Shipment ${shipmentNumber}`}
            </Typography>
          }
          subheader={
            <>
              <Typography color="textSecondary" variant="caption">
                ID #{shipment?.shipmentId || ""}
              </Typography>
              {shipment.trackingLink ? (
                <>
                  &nbsp;•&nbsp;
                  <Link href={shipment.trackingLink} variant="caption">
                    View Tracking Information
                  </Link>
                </>
              ) : null}
            </>
          }
        />

        <CardContent>
          {!shipment.hasNoShipping && (
            <Stepper alternativeLabel activeStep={step}>
              {steps.map((label, idx) => (
                <Step key={label} completed={idx < step}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          )}

          {/* Items */}
          <Box display="grid" gridGap={64}>
            {(shipment?.items || []).map((item) => (
              <ShipmentItem
                order={order}
                shipment={shipment}
                item={item}
                key={item.autographPurchaseId}
                refresh={refresh}
              />
            ))}
          </Box>
        </CardContent>

        {hasMultipleShipments && (
          <CardActions>
            <Box
              width="100%"
              display="flex"
              flexDirection="column"
              gridGap="8px"
            >
              <Button
                fullWidth
                size="small"
                startIcon={open ? <ExpandLess /> : <ExpandMore />}
                onClick={() => {
                  setOpen(B.not);
                }}
              >
                {open ? "Hide" : "Show"} Shipment Totals
              </Button>

              <Collapse in={open}>
                <ShipmentTotals shipment={shipment} />
              </Collapse>
            </Box>
          </CardActions>
        )}
      </Card>
    </Box>
  );
}

Shipment.propTypes = {
  order: PropTypes.shape({
    currency: PropTypes.string.isRequired,
  }).isRequired,
  shipment: PropTypes.shape({
    shipmentId: PropTypes.string,
    type: PropTypes.string,
    shipped: PropTypes.bool,
    delivered: PropTypes.bool,
    hasNoShipping: PropTypes.bool,
    trackingLink: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        autographPurchaseId: PropTypes.number.isRequired,
        signed: PropTypes.bool,
        received: PropTypes.bool,
      }),
    ),
  }).isRequired,
  shipmentNumber: PropTypes.number.isRequired,
  hasMultipleShipments: PropTypes.bool.isRequired,
  refresh: PropTypes.func,
};
